import React from 'react'
import colors from '../../../utils/colors'
import { Icon } from '@fluentui/react/lib/Icon'
import { /* ChevronLeft, */ ChevronRight, MoreVertical } from 'react-feather';
import { useHistory } from 'react-router-dom';
import { ActionPopup } from '../../../components';

const MapPin = () => <Icon iconName="MapPin" className="ms-MapPin text-xl" />;
const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const data = [
  {
    city: 'Bandung',
    address: 'Jl. Cijagra No.48, Cijagra, Lengkong, Kota Bandung 40265',
    pin: true,
  },
  {
    city: 'Jakarta',
    address: '-',
    pin: false,
  },
  {
    city: 'Padang',
    address: 'Jl. Prof. Dr. Hamka No.2A, Air Tawar Tim., Kec. Padang Utara, Kota Padang, Sumatera Barat 25173',
    pin: true,
  },
  {
    city: 'Aceh',
    address: 'Jl. T. Hasan Dek, Beurawe, Kec. Kuta Alam, Kota Banda Aceh, Aceh 23127',
    pin: true,
  },
]

const LocationRow = ({data, onEdit}) => {
  const [open, setOpen] = React.useState(false)
  const [popedUp, setPopedUp] = React.useState(false)
  const history = useHistory()

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr className="text-sm text-gray-444 location-row">
      <td className="align-top">
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>City</div>
        {data.city}
      </td>
      <td className="align-top">
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Address</div>
        {data.address}
      </td>
      <td className="align-top text-center" width="20%">
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Pin Point</div>
        <p style={{color: data.pin ? colors.green : '#ddd'}}><MapPin/></p>
      </td>
      <td className="relative align-top lg:align-middle">
        <div className="hidden lg:flex items-center">
          <p className="cursor-pointer underline text-sm text-gray-444 mr-6" onClick={onEdit}>Edit</p>
          <p className="cursor-pointer underline text-sm text-gray-999">Delete</p>
        </div>
        <MoreVertical className="lg:hidden text-gray-999" onClick={() => setPopedUp(true)} />
        {
          popedUp &&
          <ActionPopup
            onEdit={() => history.push('/dashboard/profile/location/edit')}
            handleClose={() => setPopedUp(false)}
          />
        }

        {/* Backup */}
        {/* <ChevronLeft className="lg:hidden" onClick={() => setOpen(true)}/> */}
        {
          open &&
          <div className="flex items-center absolute top-0 right-0 h-full">
            <div
              className="h-full flex items-center justify-end pr-4"
              style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
              onClick={() => setOpen(false)}
            >
              <ChevronRight />
            </div>
            <div
              className={`bg-primary ${actionButtonClasses}`}
              style={{...actionButtonStyles}}
              onClick={onEdit}
            >
              <Edit/>
              <p className="underline mt-2">Edit</p>
            </div>
            <div
              className={`${actionButtonClasses}`}
              style={{background: '#999', ...actionButtonStyles}}
            >
              <Delete/>
              <p className="underline mt-2">Delete</p>
            </div>
          </div>
        }
      </td>
    </tr>
  )
}

const LocationTable = ({onEdit}) => {
  return (
    <table className="table table--striped mb-8 xl:mb-0">
      <thead className="hidden lg:table-header-group">
        <tr className="text-xs">
          <th width="15%">City</th>
          <th>Address</th>
          <th width="13%" className="text-center">Pin Point</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          data.map((d, index) => (
            <LocationRow key={index} data={d} onEdit={onEdit} />
          ))
        }
      </tbody>
    </table>
  )
}

export { LocationTable }
